import React, { useState } from 'react'
import EditExpense from './EditExpense'
import { getAmount } from '../../Services/util-functions'

const Expense = props => {
  const [edit, setEdit] = useState(false)

  const handleExpenseSubmit = (desc, amount) => {
    const updatedExpense = {
      _id: props.expense._id,
      desc,
      amount,
      username: props.expense.username
    }
    setEdit(false)
    props.handleExpenseUpdated(updatedExpense, props.expenseIndex)
  }

  if (props.expense.amount) {
    return (
      <div className='active-expense-container fade-to-black'>
        <div className='active-expense font125'>
          {
            !edit
              ? (
                <div>
                  <h2 className='mb'>{props.expense.desc}</h2>
                  <p className='mb'>Amount: {getAmount(props.expense.amount)}</p>
                  <button className='mt mb block margin-auto font75 button-1' onClick={() => setEdit(true)}>Edit</button>
                  <button className='mt mb block margin-auto font75 button-1' onClick={() => props.handleExpenseDelete(props.expense, props.expenseIndex)}>Delete</button>
                </div>
              )
              : (
                <EditExpense
                  handleExpenseSubmit={handleExpenseSubmit}
                  desc={props.expense.desc}
                  amount={getAmount(props.expense.amount)}
                />
              )
          }
          <p
            className='mt font75 pointer'
            onClick={() => {
              setEdit(false)
              props.handleExpenseClosed()
            }}
          >
            Close
          </p>
        </div>
      </div>
    )
  } else return <div />
}

export default Expense
